"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.clampPeriod = void 0;
const date_fns_1 = require("date-fns");
const addMinutes_1 = __importDefault(require("date-fns/addMinutes"));
const _1 = require("./");
const clampDate_1 = require("./clampDate");
/**
 * periodをparentPeriod内にclampする
 * @param period
 * @param parentPeriod
 * @returns
 */
const clampPeriod = (period, parentPeriod) => {
    // Startの最小/最大を算出
    const minStart = parentPeriod.start;
    const maxStart = (0, date_fns_1.subMinutes)(parentPeriod.end, period.lengthInMinutes());
    // Startをclamp
    const periodStart = (0, clampDate_1.clampDate)(period.start, minStart, maxStart);
    // End = Start + periodの長さ
    const periodEnd = (0, addMinutes_1.default)(periodStart, period.lengthInMinutes());
    return new _1.Period(periodStart, periodEnd);
};
exports.clampPeriod = clampPeriod;
//# sourceMappingURL=clampPeriod.js.map